<!--==============================
=            PARALLAX            =
===============================-->
<template>
    <!-- page blank -->
    <v-container>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Parallax</div>
            </base-header>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Usage</div>
                    <div slot="card-body">
                        <v-parallax src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"></v-parallax>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" d-flex>
                <base-card class="pa-2 pl-2">
                    <div slot="card-header">With content</div>
                    <div slot="card-body">
                        <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
                            <v-row align="center" justify="center">
                                <v-col class="text-center" cols="12">
                                    <h1 class="display-1 font-weight-thin mb-4">Vuetify.js</h1>
                                    <h4 class="subheading">Build your application today!</h4>
                                </v-col>
                            </v-row>
                        </v-parallax>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card class="pa-2">
                    <div slot="card-header">Custom height</div>
                    <div slot="card-body">
                        <v-parallax height="300" src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"></v-parallax>
                    </div>
                </base-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
    components: {
        BaseCard,
        BaseHeader
    }
};
</script>
<!--====  End of PARALLAX  ====-->